import { AttributeInfo } from '../types/@types/sl-v-types';
import { VDict, Decorable } from '../types/decorable';
import { EventEmitter } from '@angular/core';
import { CastingTypeFormat } from '../components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { CastingFormatType } from '../components/att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';
import { NegativeNumberFormatting } from '../components/att-casting-view/formats/negative-numbers-sel/negative-numbers-sel.component';
import { NumberQualifierService } from './api-services/qualifiers/number-qualifier.service';
import { CastingValue } from '../components/att-casting-view/att-casting-view.component';
import { NumberSciQualifierService } from './api-services/qualifiers/number-sci-qualifier.service';
import { NumberHexQualifierService } from './api-services/qualifiers/number-hex-qualifier.service';
import { NumberOctalQualifierService } from './api-services/qualifiers/number-octal-qualifier.service';
import { NumberBinaryQualifierService } from './api-services/qualifiers/number-binary-qualifier.service';
import { NumberFractionQualifierService } from './api-services/qualifiers/number-fraction-qualifier.service';
import { FractionalValue } from '../components/att-casting-view/formats/fractional-values-sel/fractional-values-sel.component';
import { NumberPhoneQualifierService } from './api-services/qualifiers/number-phone-qualifier.service';
import { NumberZipcodeQualifierService } from './api-services/qualifiers/number-zipcode-qualifier.service';
import { DateQualifierService } from './api-services/qualifiers/date-qualifier.service';
import { LinkQualifierService } from './api-services/qualifiers/link-qualifier.service';
import { CastingLinkValue } from '../components/att-casting-view/formats/casting-link/casting-link.component';
import { BooleanQualifierService } from './api-services/qualifiers/boolean-qualifier.service';
import { CastingBooleanValue } from '../components/att-casting-view/formats/casting-boolean/casting-boolean.component';
import { GeoLocationQualifierService } from './api-services/qualifiers/geo-location-qualifier-service';


export type ValidationDict = VDict<ValidationInfo>;
export type AvailabilityDict = VDict<AvailMapEntry>;
export type AvailMapEntry = {
  available: boolean;
  attribute: AttributeInfo;
}

export type ValidationInfo = {
  isValid: boolean;
  problem?: string;
}
export type ValidationResults = {
  isValid: boolean;
  validMap: ValidationDict;
  data: any
}
export class Validator {
  private data: Decorable;
  private originalData: Decorable;

  public attributes: Array<AttributeInfo>;
  public availMap: VDict<AvailMapEntry> = {};
  public validMap: VDict<ValidationInfo> = {};
  public validityChange = new EventEmitter<ValidationResults>();
  public availMapChange = new EventEmitter<AvailabilityDict>();
  public dataChange = new EventEmitter<Validator>();

  public constructor(atts: Array<AttributeInfo>) {
    this.SetAttributes(atts);
  }
  SetAttributes(atts: Array<AttributeInfo>) {
    this.attributes = atts;
    if (!!this.data) {
      this.SetData(this.data);
    } else {
      this.availMap = {};
    }
  }
  SetData(data: Decorable) {
    if (!data) data = {};
    this.availMap = {};
    this.data = JSON.parse(JSON.stringify(data));
    for (const attribute of this.attributes) {
      this.availMap[attribute.name] = {
        available: this.IsAvailable(attribute.name),
        attribute: (attribute)
      }
    }
    this.originalData = JSON.parse(JSON.stringify(data));
    this.dataChange.emit(this);
  }
  GetData(): Decorable {
    return this.data;
  }
  GetChanged(): Decorable {
    const changes: Decorable = {};
    for (const attName in this.data) {
      const attInfo: AttributeInfo = this.availMap[attName]?.attribute;
      if ((this.originalData[attName] === this.data[attName]) && ([null, undefined].indexOf(this.originalData[attName]) > -1)) {
        continue;
      }
      if (!attInfo) continue;
      if (attInfo.casting?.entry?.geoLocPart) {
        const part = attInfo.casting.entry.geoLocPart;
        switch (part) {
          case 'lattitude':
          case 'longitude':
            if (!this.GetIsGeoriginal(attInfo.name)) {
              changes[attName] = this.data[attName];
            };
            continue;
            break;
          case 'accuracy':
            if (!this.GetIsOriginal(attInfo.name)) {
              changes[attName] = this.data[attName] ? this.data[attName] : 0;
              continue;
            }
        }
      }
      switch (attInfo.type) {
        case 'date':
          if (this.data[attName] === null) this.data[attName] = '';
      }

      if ((JSON.stringify(this.originalData[attName]) !== JSON.stringify(this.data[attName]))) {
        changes[attName] = this.data[attName];
      }
    }
    if (!!this.originalData['gid']) {
      changes['gid'] = this.originalData['gid'];
    }

    return changes;
  }
  GetIsGeoriginal(attributeName: string): boolean {
    if (!this.originalData[attributeName]) return false;
    if (!this.data[attributeName]) return false;
    return GeoLocationQualifierService.ToDegMinSec(this.data[attributeName], 2) == GeoLocationQualifierService.ToDegMinSec(this.originalData[attributeName], 2);
  }
  GetIsOriginal(attributeName: string) {
    return this.data[attributeName] == this.originalData[attributeName];
  }
  GetOriginalValue(attributeName: string) {
    return this.originalData[attributeName];
  }
  GetOriginal(): Decorable {
    if (!this.originalData) return this.GetData();
    return JSON.parse(JSON.stringify(this.originalData));
  }
  SetValue(attributeName: string, value: any) {
    if (attributeName == 'lon') {
      console.log(attributeName, value);
    }
    this.data[attributeName] = value;
    this.UpdateAvailMap();
  }
  GetValue(attributeName: string): any {
    if (!!this.data[attributeName]) {
      return this.data[attributeName];
    }
    return null;
  }
  IsAvailable(attributeName: string) {
    attributeName = null;
    /*data.hasOwnProperty(attribute.name),*/
    return true;
  }
  UpdateAvailMap() {
    const availMap: VDict<AvailMapEntry> = {};
    for (const attribute of this.attributes) {
      availMap[attribute.name] = {
        available: this.IsAvailable(attribute.name),
        attribute: (attribute)
      }
    }
    this.availMap = availMap;
    this.availMapChange.emit(this.availMap);
  }
  Validate(notify = true): ValidationResults {
    this.UpdateAvailMap();
    this.validMap = {};
    let ctr = -1;
    let validCtr = -1;
    const changesOnly = this.data.hasOwnProperty('gid');
    for (const attName in this.availMap) {
      if (this.data.hasOwnProperty(attName)) {
        ctr += 1;
        if (this.availMap.hasOwnProperty(attName)) {
          this.validMap[attName] = this.ValidateAttribute(attName, this.data[attName]);
          validCtr += (this.validMap[attName].isValid === true) ? 1 : 0;
        }
      }
    }
    const validity: ValidationResults = {
      isValid: (ctr === validCtr),
      validMap: this.validMap,
      data: changesOnly ? this.GetChanged() : this.GetData()
    };
    if (notify === true) {
      this.validityChange.emit(validity);
    }
    return validity;

  }
  ValidateAttribute(attributeName: string, value: any): ValidationInfo {
    const attInfo: AttributeInfo = this.availMap[attributeName].attribute;
    let validation: ValidationInfo = { isValid: true };
    if (attInfo.casting && attInfo.casting.entry) {
      if (attInfo.casting.entry?.geoLocPart == 'accuracy') {
        if (this.data[attributeName] === undefined) {
          value = 0;
          this.data[attributeName] = 0;
        }
      }
    }
    if (attInfo.casting && attInfo.casting.entry && attInfo.casting.entry.require) {
      if (attInfo.casting.entry.require === true) {

        const missingProperty = this.data.hasOwnProperty(attributeName) === false;
        let missingValue = false;
        if (!missingProperty) {
          if ([undefined, null, ''].indexOf(this.data[attributeName]) > -1) {
            missingValue = true;
          }
        }
        if (missingProperty || missingValue) {
          validation.isValid = false;
          validation.problem = 'Required field';
          return validation;
        }
      }
    }
    switch (attInfo.type) {
      case 'boolean':
        break;
      case 'cg_url':
        break;
      case 'date':
        if (this.data[attributeName] === '') {
          this.data[attributeName] = null;
        }
        break;
      case 'float':
        if (this.data[attributeName] === null) {
          validation.isValid = !attInfo.casting.entry?.require;
        } else {
          if (isNaN(Number(this.data[attributeName]))) {
            validation.isValid = false;
            validation.problem = 'Not a number.';
            return validation;
          }
          if (parseFloat('' + this.data[attributeName]) != this.data[attributeName]) {
            validation.isValid = false;
            validation.problem = 'Not valid decimal number.';
            return validation;
          }
        }
        break;
      case 'integer':
      case 'int':
        if (isNaN(Number(this.data[attributeName]))) {
          validation.isValid = false;
          validation.problem = 'Not an number.';
          return validation;
        }
        if (parseInt('' + this.data[attributeName]) != this.data[attributeName]) {
          validation.isValid = false;
          validation.problem = 'Not a valid integer.';
          return validation;
        }

        break;
      case 'text':
        validation = this.ValidateText(attInfo, value);
        if (validation.isValid === true) {
          this.data[attributeName] = value;
        } else {
          if (this.data.hasOwnProperty(attributeName)) {
            delete this.data[attributeName];
          }
        }
        break;
    }
    return validation;

  }
  ValidateBoolean(attribute: AttributeInfo, value: boolean) {
    attribute = value = null;
  }
  ValidateURL(attribute: AttributeInfo, value: boolean) {
    attribute = value = null;
  }
  ValidateFloat(attribute: AttributeInfo, value: number) {
    attribute = value = null;
  }
  ValidateInt(attribute: AttributeInfo, value: number) {
    attribute = value = null;
  }
  ValidateText(attribute: AttributeInfo, value: string): ValidationInfo {

    if (!!attribute.casting && !!attribute.casting.entry && !!attribute.casting.entry.text) {
      if (!!attribute.casting.entry.text.maxChars) {
        const maxChars = attribute.casting.entry.text.maxChars;
        if (value && value.length > maxChars) {
          return {
            isValid: false,
            problem: 'Exceeded maximum length of' + maxChars + ' characters'
          }
        }
      }
      if (!!attribute.casting.entry.text.minChars) {
        const minChars = attribute.casting.entry.text.minChars;
        if (value && value.length < minChars) {
          return {
            isValid: false,
            problem: 'Must be longer than ' + minChars + ' characters'
          }
        }
      }
    }
    if (this.ValidateTextFormat(attribute, 'entry', value) === false) {
      return {
        isValid: false,
        problem: 'The value entered cannot be formatted correctly for storage'
      }
    }
    return {
      isValid: true
    }
  }
  ValidateTextFormat(attribute: AttributeInfo, mode: 'display' | 'entry', value: string) {
    if (!!attribute.casting && !!attribute.casting[mode]) {
      if (attribute.casting[mode].type) {
        const type: CastingFormatType = attribute.casting[mode].type;
        switch (type) {
          case 'number-general':
            return this.ValidateNumberGeneralText(value, attribute);
          case 'number-sci':
            return this.ValidateNumberSciText(value, attribute);
          case 'number-dec':
            return this.ValidateNumberDecText(value, attribute);
          case 'number-hex':
            return this.ValidateNumberHexText(value, attribute);
          case 'number-octal':
            return this.ValidateNumberOctalText(value, attribute);
          case 'number-binary':
            return this.ValidateNumberBinaryText(value, attribute);
          case 'number-fraction':
            return this.ValidateNumberFractionText(value, attribute);
          case 'number-phone':
            return this.ValidateNumberPhoneText(value, attribute);
          case 'number-currency':
            return this.ValidateNumberCurrencyText(value, attribute);
          case 'number-percentage':
            return this.ValidateNumberPercentageText(value, attribute);
          case 'number-zipcode':
            return this.ValidateNumberZipcodeText(value, attribute);
          case 'date':
            return this.ValidateDateTimeText(value, attribute);
          case 'time':
            return this.ValidateDateTimeText(value, attribute);
          case 'text':
            return true;
          case 'link':
            return this.ValidateLinkText(value, attribute);
          case 'boolean':
            return this.ValidateBooleanText(value, attribute);
        }
      }
    }
  }
  ValidateNumberGeneralText(value: string, attribute: AttributeInfo): boolean {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const fixedDigits: number = entry.fixedDigits;
    const negFormat: NegativeNumberFormatting = attribute.casting.entry.negFormat;
    const numValue: number = NumberQualifierService.FromString(value, format);
    const formattedValue: string = NumberQualifierService.ToString(numValue, format, fixedDigits, negFormat);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberSciText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const precision: number = entry.precision;
    const numValue: number = NumberSciQualifierService.FromString(value, format);
    const formattedValue: string = NumberSciQualifierService.ToString(numValue, format, precision);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberDecText(value: string, attribute: AttributeInfo) {
    return this.ValidateNumberGeneralText(value, attribute);
  }
  ValidateNumberHexText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberHexQualifierService.FromString(value, format);
    const formattedValue: string = NumberHexQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberOctalText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberOctalQualifierService.FromString(value, format);
    const formattedValue: string = NumberOctalQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberBinaryText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberBinaryQualifierService.FromString(value, format);
    const formattedValue: string = NumberBinaryQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberFractionText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: FractionalValue = entry.fractional;
    const asFloat = ['percentage', 'convert'].indexOf(format.mode) > -1;
    const fixedDigits: number = entry.fixedDigits;
    const numValue: number = NumberFractionQualifierService.FromString(value, format, asFloat,);
    const formattedValue: string = NumberFractionQualifierService.ToString(numValue, format, fixedDigits);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberPhoneText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberPhoneQualifierService.FromString(value);
    const formattedValue: string = NumberPhoneQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberCurrencyText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberQualifierService.FromString(value, format, entry.currency);
    const formattedValue: string = NumberQualifierService.ToString(numValue, format, entry.fixedDigits, entry.negFormat, entry.currency);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberPercentageText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: FractionalValue = entry.fractional;
    const asFloat = ['percentage', 'convert'].indexOf(format.mode) > -1;
    const fixedDigits: number = entry.fixedDigits;
    const numValue: number = NumberFractionQualifierService.FromString(value, format, asFloat,);
    const formattedValue: string = NumberFractionQualifierService.ToString(numValue, format, fixedDigits);
    return formattedValue.trim() === value.trim();
  }
  ValidateNumberZipcodeText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: number = NumberZipcodeQualifierService.FromString(value, format);
    const formattedValue: string = NumberZipcodeQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateDateTimeText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingTypeFormat = entry.format;
    const numValue: Date = DateQualifierService.FromString(value, format);
    const formattedValue: string = DateQualifierService.ToString(numValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateLinkText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingLinkValue = entry.link;
    const stringValue: string = LinkQualifierService.FromString(value, format);
    const formattedValue: string = LinkQualifierService.ToString(stringValue, format);
    return formattedValue.trim() === value.trim();
  }
  ValidateBooleanText(value: string, attribute: AttributeInfo) {
    const entry: CastingValue = attribute.casting.entry;
    const format: CastingBooleanValue = entry.boolean;
    const boolValue: boolean = BooleanQualifierService.FromString(value, format);
    const formattedValue: string = BooleanQualifierService.ToString(boolValue, format);
    return formattedValue.trim() === value.trim();
  }


}
